import React, { useEffect } from "react";
import { PROMO_CONFIG } from "./promo.config";

const PromoSuccess = ({ data }) => {
  useEffect(() => {
    const message = `
Halo Admin Honda Berdikari Pamulang,
Saya ingin menanyakan promo/voucher 10%.

Nama: ${data.name}
Email: ${data.email}
No HP: ${data.phone}

Kode Voucher: ${PROMO_CONFIG.voucherCode}
    `;

    const url = `https://wa.me/${PROMO_CONFIG.whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.location.href = url;
  }, [data]);

  return (
    <div className="bg-white p-10">
      <h2 className="text-2xl font-bold">
        Mengarahkan ke WhatsApp...
      </h2>
    </div>
  );
};

export default PromoSuccess;
